export default "__VITE_ASSET__3274d763__"